import * as React from "react";

function TrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M424 80c13.3 0 24 10.75 24 24 0 13.3-10.7 24-24 24h-11.6l-24 324.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.48 0-61.31-25.9-63.79-59.3L35.56 128H24c-13.25 0-24-10.7-24-24 0-13.25 10.75-24 24-24h69.82l36.68-55.06C140.9 9.357 158.4 0 177.1 0h93.8c18.7 0 36.2 9.358 46.6 24.94L354.2 80H424zM177.1 48c-2.6 0-6 1.34-6.6 3.56L151.5 80h145l-19-28.44c-1.5-2.22-4-3.56-6.6-3.56h-93.8zm187.2 80H83.69l23.81 321.2c.6 8.3 7.6 14.8 15.9 14.8h201.2c8.3 0 15.3-6.5 15.9-14.8L364.3 128z"
  }));
}

const ForwardRef = React.forwardRef(TrashIcon);
export default ForwardRef;